import { GetStaticPaths, GetStaticProps } from "next";
import parlors from "goi_common/src/constants/parlors_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import {
  ATypeCompareParlor,
  EXCLUDED_IDS_BY_REGION,
  ParlorDetailProps,
  RichSearch,
  sangjoFaqRichSearch,
} from "goi_common";
import { Box, Stack } from "@mui/material";
import Head from "next/head";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const excludedSet = EXCLUDED_IDS_BY_REGION.dggb ?? new Set<number>();

  const parlorList = parlors
    .filter((res) => targetSidos.includes(res.sido))
    .filter((res) => !excludedSet.has(res.id));

  let pathList = [] as Array<any>;
  let copyParlorList = [...parlorList];

  while (copyParlorList.length > 0) {
    let firstParlor = copyParlorList[0];

    if (excludedSet.has(firstParlor.id)) {
      copyParlorList.shift();
      continue;
    }

    copyParlorList.map((secondParlor) => {
      if (
        firstParlor.companyname !== secondParlor.companyname &&
        firstParlor.sigungu === secondParlor.sigungu
      ) {
        pathList.push({
          params: {
            firstid: String(firstParlor.id),
            secondid: String(secondParlor.id),
          },
        });
      }
    });
    copyParlorList.shift();
  }

  return {
    paths: pathList,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { firstid, secondid } = params as { firstid: string; secondid: string };

  const firstParlor = parlors.filter((p) => String(p.id) === firstid)[0];
  const secondParlor = parlors.filter((p) => String(p.id) === secondid)[0];

  let description = `(고이장례연구소, e하늘 장사정보시스템 기반) ${firstParlor.companyname}과 ${
    secondParlor.companyname
  }은 ${firstParlor.address.split(" ")[0]}에 위치한 장례식장으로, 각각 ${
    firstParlor.managed_type
  } 장례식장, ${secondParlor.managed_type} 장례식장으로 분류됩니다.
  아래에서 ${firstParlor.companyname}과 ${
    secondParlor.companyname
  }을 한번 비교해보겠습니다.`;

  return {
    props: {
      firstParlor,
      secondParlor,
      pageDescription: description,
      pageKeywords: `${firstParlor.companyname} 장례 서비스, ${firstParlor.companyname} 얼마, ${firstParlor.companyname} 앰뷸런스, ${firstParlor.companyname} 수의, ${firstParlor.companyname} 유골함, ${firstParlor.companyname} 도우미, ${firstParlor.companyname} 비용, ${firstParlor.companyname} 할인, ${firstParlor.companyname} 전화번호,
      ${secondParlor.companyname} 장례 서비스, ${secondParlor.companyname} 얼마, ${secondParlor.companyname} 앰뷸런스, ${secondParlor.companyname} 수의, ${secondParlor.companyname} 유골함, ${secondParlor.companyname} 도우미, ${secondParlor.companyname} 비용, ${secondParlor.companyname} 할인, ${secondParlor.companyname} 전화번호`,
      pageOgTitle: `${firstParlor.companyname} vs ${secondParlor.companyname} 비교 (비용, 시설, 접근성) | 대구경북장례정보 [고이장례연구소]`,
      pageOgDescription: description,
      pageOgImage: firstParlor?.images[0]?.url || "",
    },
  };
};

export default function placeComaprePage({
  firstParlor,
  secondParlor,
  pageOgTitle,
}: {
  firstParlor: ParlorDetailProps;
  secondParlor: ParlorDetailProps;
  pageOgTitle: string;
}) {
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>

        <RichSearch data={sangjoFaqRichSearch} />
      </Head>
      <Stack>
        <ATypeCompareParlor
          firstParlor={firstParlor}
          secondParlor={secondParlor}
          mainColor={regionColor}
          event={{
            domain: "dggb",
            path: "compare_prlr",
            trigger_and_target: "uv_prlr_detail",
          }}
        />
      </Stack>
    </>
  );
}
